import { bookType, OptimizedBook } from '@/models/Book';
import Lesson from '@/models/Lesson';

export const toLessonBookPatch = (
  bookType: bookType,
  book: OptimizedBook | null,
): Partial<Pick<Lesson, 'book' | 'teacherBook'>> =>
  bookType === 'STUDENT' ? { book } : { teacherBook: book?.id ?? null };
